import { useMemo, useState } from 'react'
import { Button, Form } from 'react-bootstrap'

import accessorizeImg from '../../imgs/category/accessorize.png'
import bagImg from '../../imgs/category/bag.png'
import beautyCreamsMakeupImg from '../../imgs/category/beauty-creams-makeup.png'
import cameraImg from '../../imgs/category/camera.png'
import chipsDoritosImg from '../../imgs/category/chips-doritos.png'
import coffeeCapsulesImg from '../../imgs/category/coffee-capsules.png'
import computerEqImg from '../../imgs/category/computer-eq.png'
import dressImg from '../../imgs/category/dress.png'
import electronicsImg from '../../imgs/category/electronics.png'
import electronicsBatteriesImg from '../../imgs/category/electronics-batteries.png'
import contactLensesImg from '../../imgs/category/eye-lens.png'
import homeAppliancesImg from '../../imgs/category/home-appliances.png'
import homeTextileImg from '../../imgs/category/home-textile.png'
import jewelleryImg from '../../imgs/category/jewellery.png'
import laptopImg from '../../imgs/category/laptop.png'
import mobileImg from '../../imgs/category/mobile.png'
import pantsImg from '../../imgs/category/pants.png'
import perfumesImg from '../../imgs/category/perfumes.png'
import shirtImg from '../../imgs/category/shirt.png'
import shoesImg from '../../imgs/category/shoes.png'
import sportsImg from '../../imgs/category/sports-eq.png'
import suitsImg from '../../imgs/category/suits.png'
import supplementsImg from '../../imgs/category/supplements.png'
import toysImg from '../../imgs/category/toys.png'
// Icons
import underwearImg from '../../imgs/category/underwear.png'
import wafflesBiscuitsImg from '../../imgs/category/waffles-biscuits.png'
import watchesImg from '../../imgs/category/watches.png'
import flammableIcon from '../../imgs/flammable.png'
import notFlammableIcon from '../../imgs/not-flammable.png'

export default function PackageContents({ onContentAdded, onContentsRemoved, packageState, setPackageState, warehouse }) {
  const [newContentState, setNewContentState] = useState({
    productCategory: '',
    quantity: 0,
  })

  const stateWarehouse = useMemo(() => {
    return packageState.warehouse || warehouse
  }, [packageState.warehouse, warehouse])

  const onAddContentClick = () => {
    onContentAdded(newContentState)
    setNewContentState({ productCategory: '', quantity: 0 })
  }

  const onRemoveContentClick = index => {
    onContentsRemoved(index)
  }

  const clickHandler = (ev, category) => {
    setNewContentState({ ...newContentState, productCategory: category })
  }
  const onChangeFlammable = isFlammable => {
    if (stateWarehouse !== 'USA') {
      if (isFlammable && packageState.contents.some(c => NON_FLAMMABLE_ITEMS.some(item => item.type === c.productCategory))) {
        alert('To change to "Flammable", you need to remove the non-flammable items first')
        return
      }
      if (!isFlammable && packageState.contents.some(c => FLAMMABLE_ITEMS.some(item => item.type === c.productCategory))) {
        alert('To change to "Non-Flammable", you need to remove the flammable items first')
        return
      }
    }

    setPackageState({
      ...packageState,
      isFlammable: isFlammable,
    })
  }
  const itemsToShow = useMemo(() => {
    return NON_FLAMMABLE_ITEMS.filter(item => item.countries.includes('all') || item.countries.includes(stateWarehouse))
  }, [stateWarehouse])
  return (
    <div className='package-content-cmp'>
      <div className='is-flammable-cont'>
        <h4>Package Type</h4>
        <div className='is-flammable-options-cont'>
          <div
            className={`is-flammable-option ${packageState.isFlammable === false ? 'is-flammable-option-chosen' : ''}`}
            onClick={() => onChangeFlammable(false)}
          >
            <div className='flammable-title'>Not Flammable</div>
            <img src={notFlammableIcon} alt='not flammable' />
          </div>

          <div
            className={`is-flammable-option ${packageState.isFlammable === true ? 'is-flammable-option-chosen' : ''}`}
            onClick={() => onChangeFlammable(true)}
          >
            <div className='flammable-title'>Flammable</div>
            <img src={flammableIcon} alt='flammable' />
          </div>
        </div>
      </div>

      <div className='packages-content-cont'>
        <h4 style={{ textAlign: 'center' }}>Package Content</h4>
        <h6>Category</h6>

        {stateWarehouse !== 'USA' && (
          <div className='types-img-cont'>
            {!packageState.isFlammable ? (
              itemsToShow.map(item => (
                <div className={`type-card ${newContentState.productCategory === item.type ? 'type-card-chosen' : ''}`} key={item.type}>
                  <div className='type-card-title'>{item.type}</div>
                  <img src={item.img} onClick={ev => clickHandler(ev, item.type)} alt='clothes-img' />
                </div>
              ))
            ) : (
              <div className='liquids-cont'>
                <h4>Liquids</h4>
                <div className='liquids-cont-cards'>
                  {FLAMMABLE_ITEMS.map(item => (
                    <div className={`type-card ${newContentState.productCategory === item.type ? 'type-card-chosen' : ''}`} key={item.type}>
                      <div className='type-card-title'>{item.type}</div>
                      <img src={item.img} onClick={ev => clickHandler(ev, item.type)} alt='clothes-img' />
                    </div>
                  ))}
                </div>
                {/* <div className='liquids-cont-cards'>
                  <div className='type-card'>
                    <div className='type-card-title'>Perfumes</div>
                    <img src={perfumesImg} onClick={ev => clickHandler(ev, 'Perfumes')} alt='clothes-img' />
                  </div>
                  <div className='type-card'>
                    <div className='type-card-title'>Electronic Devices With Batteries</div>
                    <img
                      src={electronicsBatteriesImg}
                      onClick={ev => clickHandler(ev, 'Electronic Devices With Batteries')}
                      style={{ width: '130px' }}
                    />
                  </div>
                  <div className='type-card'>
                    <div className='type-card-title'>Beauty Creams and Makeup</div>
                    <img src={beautyCreamsMakeupImg} onClick={ev => clickHandler(ev, 'Beauty Creams and Makeup')} alt='clothes-img' />
                  </div>
                  <div className='type-card'>
                    <div className='type-card-title'>Personal Care</div>
                    <img src={beautyCreamsMakeupImg} onClick={ev => clickHandler(ev, 'Personal Care')} alt='clothes-img' />
                  </div>
                </div> */}
              </div>
            )}
          </div>
        )}

        {stateWarehouse == 'USA' && (
          <div className='types-img-cont'>
            {itemsToShow.map(item => (
              <div className={`type-card ${newContentState.productCategory === item.type ? 'type-card-chosen' : ''}`} key={item.type}>
                <div className='type-card-title'>{item.type}</div>
                <img src={item.img} onClick={ev => clickHandler(ev, item.type)} alt='clothes-img' />
              </div>
            ))}
          </div>
        )}

        <Form.Group style={{ margin: '0 1.5rem 0 0' }}>
          <Form.Label>Quantity</Form.Label>
          <div className='add-form-flex'>
            <Form.Control
              style={{ width: '20%' }}
              value={newContentState.quantity}
              type='number'
              onChange={e =>
                setNewContentState({
                  ...newContentState,
                  quantity: +e.target.value,
                })
              }
            ></Form.Control>
            {Array.from({ length: 7 }, (_, i) => (
              <div className='content-number' key={i} onClick={() => setNewContentState({ ...newContentState, quantity: i + 1 })}>
                {i + 1}
              </div>
            ))}
          </div>
        </Form.Group>

        <Button
          style={{ marginTop: '15px' }}
          variant='outline-secondary'
          onClick={onAddContentClick}
          disabled={!newContentState.quantity || !newContentState.productCategory}
          block
        >
          Add
        </Button>
      </div>
      <table>
        <tbody>
          {packageState.contents.map((c, i) => {
            return (
              <tr key={i}>
                <td className='font-weight-bold'>
                  {c.quantity}
                  <span> X </span>
                </td>
                <td>
                  <span>{c.productCategory}</span>
                  <span className='alert-warning font-italic ml-4' style={{ cursor: 'pointer' }} onClick={() => onRemoveContentClick(i)}>
                    remove
                  </span>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
const FLAMMABLE_ITEMS = [
  {
    type: 'Perfumes',
    img: perfumesImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Electronic Devices With Batteries',
    img: electronicsBatteriesImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Beauty Creams and Makeup',
    img: beautyCreamsMakeupImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Personal Care',
    img: beautyCreamsMakeupImg,
    countries: ['UK', 'GR', 'UK'],
  },
]
const NON_FLAMMABLE_ITEMS = [
  {
    type: 'Underwear',
    img: underwearImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Pants',
    img: pantsImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Shirt',
    img: shirtImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Skirt',
    img: dressImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Accessorize',
    img: accessorizeImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Bag',
    img: bagImg,
    countries: ['all'],
  },
  {
    type: 'Cosmetics',
    img: beautyCreamsMakeupImg,
    countries: ['USA'],
  },
  {
    type: 'Cell Phones',
    img: mobileImg,
    countries: ['USA'],
  },
  {
    type: 'Clothing',
    img: shirtImg,
    countries: ['USA'],
  },
  {
    type: 'Watches',
    img: watchesImg,
    countries: ['USA'],
  },
  {
    type: 'Supplements',
    img: supplementsImg,
    countries: ['USA'],
  },
  {
    type: 'Laptop',
    img: laptopImg,
    countries: ['USA'],
  },
  {
    type: 'Jewelry',
    img: jewelleryImg,
    countries: ['USA'],
  },
  {
    type: 'Food',
    img: wafflesBiscuitsImg,
    countries: ['USA'],
  },
  {
    type: 'Housewares',
    img: homeTextileImg,
    countries: ['USA'],
  },
  {
    type: 'Computer Equipment',
    img: computerEqImg,
    countries: ['USA'],
  },
  {
    type: 'Camera',
    img: cameraImg,
    countries: ['USA'],
  },
  {
    type: 'Sports Equipment',
    img: sportsImg,
    countries: ['USA'],
  },
  {
    type: 'Jackets',
    img: suitsImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Shoes',
    img: shoesImg,
    countries: ['all'],
  },
  {
    type: 'Toys',
    img: toysImg,
    countries: ['all'],
  },
  {
    type: 'Home Appliances',
    img: homeAppliancesImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Electronic Devices',
    img: electronicsImg,
    countries: ['all'],
  },
  {
    type: 'Home Textile',
    img: homeTextileImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Jewellery',
    img: jewelleryImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Chips & Doritos',
    img: chipsDoritosImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Waffles & Biscuits',
    img: wafflesBiscuitsImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Coffee Capsules',
    img: coffeeCapsulesImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Personal Care',
    img: beautyCreamsMakeupImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Beauty Creams and Makeup',
    img: beautyCreamsMakeupImg,
    countries: ['UK', 'GR', 'UK'],
  },
  {
    type: 'Contact Lenses',
    img: contactLensesImg,
    countries: ['UK', 'GR', 'UK'],
  },
]
